import { Link } from "react-router-dom";
import { PhoneCall, ShieldCheck, CalendarCheck, Building2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CLINIC } from "@/data/content";

const CtaBand = ({
  title = "Speak Confidentially with Dr. Ankur Lal",
  text = "Expert, judgment-free sexual-health care — online or in clinic.",
  dark = true,
}) => (
  <section
    className={`relative overflow-hidden ${
      dark ? "bg-emerald-950 text-emerald-50" : "bg-secondary text-slate-900"
    }`}
    data-testid="cta-band"
  >
    <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-emerald-700/20 blur-3xl pointer-events-none" />
    <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-amber-500/10 blur-3xl pointer-events-none" />
    <div className="relative max-w-5xl mx-auto px-5 sm:px-8 py-16 sm:py-20 text-center">
      <Reveal>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight">
          {title}
        </h2>
        <p className={`mt-4 max-w-2xl mx-auto leading-relaxed ${dark ? "text-emerald-100/80" : "text-slate-600"}`}>
          {text}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/booking?type=online"
            data-testid="cta-book-online"
            className={`inline-flex items-center gap-2 font-semibold text-sm px-7 py-3.5 rounded-full transition-all shadow-lg hover:-translate-y-0.5 ${
              dark ? "bg-amber-500 hover:bg-amber-400 text-slate-950" : "bg-emerald-900 hover:bg-emerald-800 text-white"
            }`}
          >
            <CalendarCheck className="w-4 h-4" /> Book Online Consultation
          </Link>
          <Link
            to="/booking?type=clinic"
            data-testid="cta-book-clinic"
            className={`inline-flex items-center gap-2 font-semibold text-sm px-7 py-3.5 rounded-full border transition-all hover:-translate-y-0.5 ${
              dark
                ? "border-emerald-300/40 text-emerald-50 hover:bg-emerald-900"
                : "border-slate-400 text-slate-800 hover:bg-white"
            }`}
          >
            <Building2 className="w-4 h-4" /> Book Clinic Appointment
          </Link>
          <a
            href={`tel:${CLINIC.phoneRaw}`}
            data-testid="cta-call"
            className={`inline-flex items-center gap-2 font-semibold text-sm px-7 py-3.5 rounded-full transition-all hover:-translate-y-0.5 ${
              dark ? "text-emerald-100 hover:text-white underline underline-offset-8 decoration-emerald-400/50" : "text-emerald-900 underline underline-offset-8"
            }`}
          >
            <PhoneCall className="w-4 h-4" /> Call the Clinic
          </a>
        </div>
        <p
          className={`mt-7 inline-flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase font-semibold ${
            dark ? "text-emerald-200/80" : "text-emerald-900/80"
          }`}
        >
          <ShieldCheck className="w-4 h-4" /> Confidential • Professional • Judgment-Free
        </p>
      </Reveal>
    </div>
  </section>
);

export default CtaBand;
